import { useState } from "react";

function Faq() {
  const [activeQ, setActiveQ] = useState("q1");

  const openQ = (id) => {
    setActiveQ(activeQ === id ? "" : id);
  };

  const getClassAnswer = (id) => {
    return activeQ === id ? "active-answer" : "";
  };

  const getClassQuestion = (id) => {
    return activeQ === id ? "active-question" : "";
  };

  return (
    <>
      <section className="faq-section py-20 bg-gray-100" style={{fontFamily:'Montserrat'}}>
        <div className="container px-6 mx-auto">
          <div className="faq-content">
            <div className="faq-content__title text-center mb-12">
              <h5 className="text-xl font-semibold text-blue-600">FAQ</h5>
              <h2 className="text-3xl font-semibold mb-4" style={{fontSize:'30px'}}>Wakaforme Ride - Frequently Asked Questions</h2>
              <p className="text-lg text-gray-600" style={{fontFamily:'Montserrat'}}>
              Find answers to commonly asked questions about booking, selecting rides, payments, and enjoying your journey with Wakaforme Ride service.
              </p>
            </div>

            <div className="all-questions">
              <div className="faq-box mb-6">
                <div style={{ background:'#f7931e', color:'white'}}
                  id="q1"
                  onClick={() => openQ("q1")}
                  className={`faq-box__question ${getClassQuestion("q1")} cursor-pointer p-4 bg-white rounded-xl shadow-lg transition-all duration-300 hover:bg-blue-50`}
                >
                  <p className="font-semibold text-xl" style={{fontFamily:'Montserrat'}}>1. How do I book a ride with Wakaforme Ride?</p>
                  <i className={`fa-solid fa-angle-down ${activeQ === "q1" ? "rotate-180" : ""} transition-transform`}></i>
                </div>
                <div style={{fontFamily:'Montserrat'}}
                  id="q1"
                  className={`faq-box__answer ${getClassAnswer("q1")} p-4 bg-blue-50 rounded-b-xl text-gray-700 transition-all duration-300`}
                >
                  To book a ride, simply visit our website, select the car you prefer, customize your ride based on your preferences, and confirm your booking. After that, you’ll be guided through the payment process to finalize your reservation.
                </div>
              </div>

              <div className="faq-box mb-6">
                <div 
                  id="q2"
                  onClick={() => openQ("q2")}
                  className={`faq-box__question ${getClassQuestion("q2")} cursor-pointer p-4 bg-white rounded-xl shadow-lg transition-all duration-300 hover:bg-blue-50`}
                >
                  <p className="font-semibold text-xl">2. What types of vehicles can I choose from?</p>
                  <i className={`fa-solid fa-angle-down ${activeQ === "q2" ? "rotate-180" : ""} transition-transform`}></i>
                </div>
                <div style={{fontFamily:'Montserrat'}}
                  id="q2"
                  className={`faq-box__answer ${getClassAnswer("q2")} p-4 bg-blue-50 rounded-b-xl text-gray-700 transition-all duration-300`}
                >
                  We offer a wide range of vehicles, including compact cars, sedans, SUVs, and luxury vehicles. You can easily choose the one that fits your needs and preferences from our selection of cars available for booking.
                </div>
              </div>

              <div className="faq-box mb-6">
                <div
                  id="q3"
                  onClick={() => openQ("q3")}
                  className={`faq-box__question ${getClassQuestion("q3")} cursor-pointer p-4 bg-white rounded-xl shadow-lg transition-all duration-300 hover:bg-blue-50`}
                >
                  <p className="font-semibold text-xl">3. What payment methods do you accept?</p>
                  <i className={`fa-solid fa-angle-down ${activeQ === "q3" ? "rotate-180" : ""} transition-transform`}></i>
                </div>
                <div style={{fontFamily:'Montserrat'}}
                  id="q3"
                  className={`faq-box__answer ${getClassAnswer("q3")} p-4 bg-blue-50 rounded-b-xl text-gray-700 transition-all duration-300`}
                >
                  We accept a variety of payment methods, including credit/debit cards, PayPal, and mobile payments like Google Pay and Apple Pay. You can choose your preferred method during the checkout process.
                </div>
              </div>

              <div className="faq-box mb-6">
                <div
                  id="q4"
                  onClick={() => openQ("q4")}
                  className={`faq-box__question ${getClassQuestion("q4")} cursor-pointer p-4 bg-white rounded-xl shadow-lg transition-all duration-300 hover:bg-blue-50`}
                >
                  <p className="font-semibold text-xl">4. Can I modify my booking after confirmation?</p>
                  <i className={`fa-solid fa-angle-down ${activeQ === "q4" ? "rotate-180" : ""} transition-transform`}></i>
                </div>
                <div style={{fontFamily:'Montserrat'}}
                  id="q4"
                  className={`faq-box__answer ${getClassAnswer("q4")} p-4 bg-blue-50 rounded-b-xl text-gray-700 transition-all duration-300`}
                >
                  Yes, you can modify your booking, including the car choice and pickup details, up to 24 hours before the scheduled pickup time. Any changes to the booking will be reflected in your final invoice.
                </div>
              </div>

              <div className="faq-box mb-6">
                <div
                  id="q5"
                  onClick={() => openQ("q5")}
                  className={`faq-box__question ${getClassQuestion("q5")} cursor-pointer p-4 bg-white rounded-xl shadow-lg transition-all duration-300 hover:bg-blue-50`}
                >
                  <p className="font-semibold text-xl">5. What happens if I cancel my booking?</p>
                  <i className={`fa-solid fa-angle-down ${activeQ === "q5" ? "rotate-180" : ""} transition-transform`}></i>
                </div>
                <div style={{fontFamily:'Montserrat'}}
                  id="q5"
                  className={`faq-box__answer ${getClassAnswer("q5")} p-4 bg-blue-50 rounded-b-xl text-gray-700 transition-all duration-300`}
                >
                  If you cancel your booking at least 48 hours in advance, you will receive a full refund. Cancellations made within 48 hours may incur a small cancellation fee, depending on the terms and conditions of your booking.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq;
